import React, { Fragment } from 'react';
import { NavLink, withRouter } from "react-router-dom";

function ConditionalLink({ active, children, history, isActive, location, match, staticContext, ...rest }) {
  return (
    active
    ? (
      <NavLink
        isActive={isActive}
        { ...rest }
      >
        {children}
      </NavLink>
    )
    : (
      <Fragment>
        {(!isActive || isActive(match, location))
          ? children
          : undefined
        }
      </Fragment>
    )
  );
}

export default withRouter(ConditionalLink);
